let loader = null

function load(siteKey) {
    if (window.grecaptcha && window.grecaptcha.execute) {
        return Promise.resolve(window.grecaptcha)
    }
    if (loader) return loader
    loader = new Promise((resolve, reject) => {
        const s = document.createElement('script')
        s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
        s.async = true
        s.defer = true
        s.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha))
        s.onerror = reject
        document.head.appendChild(s)
    })
    return loader
}

export async function getCaptchaToken(action) {
    const siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY
    const g = await load(siteKey)
    return g.execute(siteKey, { action })
}

// Optional: preload on page mount so the first submit isn't delayed
export function preloadCaptcha() {
    return load(process.env.VUE_APP_RECAPTCHA_SITE_KEY)
}